import questions from "./questions";

export default {
    questions
}
